export const GET_RECEIPT_DETAIL='GET_RECEIPT_DETAIL'
export const GET_RECEIPT_DETAIL_SUCCESS='GET_RECEIPT_DETAIL_SUCCESS'
export const GET_RECEIPT_DETAIL_ERROR='GET_RECEIPT_DETAIL_ERROR'

export const GetReceiptDetail = (data) => ({
    type: GET_RECEIPT_DETAIL,
    payload: data
})